import React from 'react';

/** `<sc-for>`: maps a list, rendering nothing when it is not an array. */
export function each(list: any, fn: (item: any, index: number) => React.ReactNode): React.ReactNode {
  return Array.isArray(list) ? list.map(fn) : null;
}

/**
 * Text interpolation `{{value}}`: like the design runtime, a scalar renders inside
 * `span.sc-interp`, elements and arrays render as they are, null and booleans render nothing.
 */
export function ip(value: unknown): React.ReactNode {
  if (value === undefined || value === null || typeof value === 'boolean') return null;
  if (React.isValidElement(value) || Array.isArray(value)) return value as React.ReactNode;
  return <span className="sc-interp">{String(value)}</span>;
}

/** Style string with interpolated declarations → React style object (runtime `st()`). */
export function sx(style: string): React.CSSProperties {
  const out: Record<string, string> = {};
  for (const decl of style.split(';')) {
    const i = decl.indexOf(':');
    if (i < 0) continue;
    const k = decl.slice(0, i).trim();
    if (!k) continue;
    out[k.startsWith('--') ? k : k.replace(/-([a-z])/g, (_m, c: string) => c.toUpperCase())] = decl.slice(i + 1).trim();
  }
  return out as React.CSSProperties;
}

/** Design file links (`TRD-02_account-overview.html?login=…`) → panel routes (`/account-overview?login=…`). */
export function route(href: unknown): string | undefined {
  if (href == null || href === '') return undefined;
  const s = String(href);
  const m = s.match(/^([A-Z]+[0-9]?-\d{2})_([a-z0-9-]+)\.html(.*)$/);
  if (m) return '/' + m[2] + (m[3] || '');
  if (s === 'index.html') return '/';
  return s;
}

/** Row click of a `bx-link-row`: opens the row's first link unless a control inside the row was clicked. */
export function rowClick(e: React.MouseEvent<HTMLElement>) {
  if ((e.target as Element).closest('a,button,input,label,select,textarea')) return;
  (e.currentTarget.querySelector('a[href]') as HTMLAnchorElement | null)?.click();
}
